import useKeyStroke from '../hooks/useKeyStroke';
import { useDocReaderDispatch } from '../store/docReaderContext';

export default function useDocReaderKeyStrokes() {
    const dispatch = useDocReaderDispatch();
    useKeyStroke('ArrowLeft', () => dispatch({ type: 'pagePrev' }));
    useKeyStroke('ArrowRight', () => dispatch({ type: 'pageNext' }));
    useKeyStroke('ArrowUp', () => dispatch({ type: 'pagePrev' }));
    useKeyStroke('ArrowDown', () => dispatch({ type: 'pageNext' }));
    useKeyStroke('Escape', () => dispatch({ type: 'fullScreenOut' }));
}
